/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */

/*
 *
 * Recycle pool for maintaining recyclable items (dis-engaged cells)
 */

type AvailabilitySet = {
    [key: string]: number;
};

export default class RecycleItemPool {
    private _availabilitySet: AvailabilitySet;

    constructor() {
        this._availabilitySet = {};
    }

    public addKey = (key: string) => {
        this._availabilitySet[key] = 1;
    };

    public getKey = () => {
        const key = Object.keys(this._availabilitySet)[0];

        if (key) {
            delete this._availabilitySet[key];
            return key;
        }

        return undefined;
    };

    public removeKey = (key: string) => {
        if (this._availabilitySet[key]) {
            delete this._availabilitySet[key];
            return true;
        }

        return false;
    };

    public removeAll = () => {
        this._availabilitySet = {};
    };
}
